<template>
  <div id="form" class="modal with-header white" ref="modal">
    <div class="header-wrapper">
      <div class="modal-header">
        <div class="title" v-html="sectionTitle">
        </div>
        <ul class="right">
          <li>
            <a class="">
              <i class="material-icons grey-text text-darken-3">minimize</i>
            </a>
          </li>
          <li>
            <a @click="$_toggleFullScreen()">
              <i v-if="!fullScreen" class="material-icons grey-text text-darken-3">
                fullscreen
              </i>
              <i v-else class="material-icons grey-text text-darken-3">
                fullscreen_exit
              </i>              
            </a>
          </li>
          <li>
            <a class="goBack" @click="$_goBack()">
              <i class="material-icons grey-text text-darken-3">close</i>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <transition name="fade-in">
   
   <div class="modal-content grey lighten-4" v-if="ready">
    <div class="form-fields">
      <div
      
      v-for="(field, index) in fields" v-bind:key="index">
        <field-types
         :class="field.layout"
          @uploads="$_filesToUpload($event)"
          @update="$_fieldsData($event)"
          :data-option="field"
           v-if="$_evaluateField(field)"
        >
        <!--  v-show="!field.isFor || field.isFor === toPost.entry_type" -->
        </field-types>
     
      </div>

<!--         <div class="find-user-wrapper col s12">
          <div class="col s12 input-field flex-col no-padding">
            <div class="chips-over" ref="chipsOver">
            <div class="chip custom" v-for="(option, i) in chipRepeater" :key="i">{{option.phrase}}
              <i @click.prevent="chipRepeater.splice(i,1)" class=" material-icons right action">close</i>
            </div>
            </div>
            <input type="text" ref="userSearch"  @keypress.enter="() =>{
              chipRepeater.push({phrase:customChips})
              customChips =''
              }" name="userSearch" v-model="customChips" id="userSearch" placeholder="Enter name or email of person / company">
          </div>
        </div> -->

    </div>
     <div>
     </div>
   </div>
    </transition>
   <div class="loader-container" v-if="!ready">
        <div 
        class="preloader-wrapper small active">
          <div class="spinner-layer spinner-blue-only">
            <div class="circle-clipper left">
              <div class="circle"></div>
            </div><div class="gap-patch">
              <div class="circle"></div>
            </div><div class="circle-clipper right">
              <div class="circle"></div>
            </div>
          </div>
        </div>
   </div>
    <div class="custom-footer">
      <div class="col left hide">
      <p style="margin:0px;">
        <label>
          <input v-model="notify"  type="checkbox" />
          <span>Send Notification</span>
        </label>
      </p>
      </div>
      <button
        :disabled="sending || !validateForm"
        @click="$_saveCheck()"
        class="btn z-depth-0 right">
        Publish Entry
      </button>
      <button class="btn btn-flat waves-effect transparent right" @click="$_goBack()">
        Cancel
      </button>
      <div class="clear"></div>
    </div>
  </div>
</template>
<script>
import formService from '@/services/formService'
import core from '@/functions'
import fieldTypes from '@/components/records/fieldTypes.component' // records form is original template
import libraryFields from '@/components/library/library-entry'
import {mapState} from 'vuex'
import contentService from '@/services/contentService'
export default {
  name:'LibraryEntryForm',
  components:{
    fieldTypes,
  },
  data(){
    let vm = this
    return {
      chipRepeater: [],
      customChips: '',
     // fields:libraryFields.fields,
      curr_index:0,
      notify:false,
      fields:'',
      content: false,
      post: new Object,
      sending:false,
      fullScreen:false,
      ready:false,
      popFields: {},
      uploads:{
        data:new Array,
        ready:false,
        added:new Array, 
      },
      modal:{
        options:{
          onOpenStart:()=>{
              vm.ready = true 
          },
          onOpenEnd:()=>{
            core.updateFields()
          },
          dismissible:false
        },
        instance:null,
      }
    }
  },
  watch:{
    $route:function(nV){
      nV 
      ? this.modal.instance.close()
      : false
    },
  },
  created () {
    if (this.$route.name === 'view_item'){
      this.$_fetchTs()
    }
  },
  mounted(){   
    this.$_vModal()
   // Object.assign(this.fields, libraryFields.fields)
   this.fields = libraryFields.generate()
    //this.fields.forEach(option => option.type !== 'date' ? option.values = "" : false)         
  },
  beforeDestroy(){
    try{
      this.modal.instance.close()
      this.modal.instance !== null 
      ? this.modal.instance.destroy()
      : false
    }catch(e){
      //console.log(e)
    }
       setTimeout(() => {
        this.fields.forEach(x => {
          
            this.$_fieldsData({
            name:x.name,
            data: ""
          })
          
 
        })
      }, 100);
  },
  computed:{
    ...mapState({
      users:state=> state.record.users,
    }),
    baseOption: {
      get () {
        let record = this.fields.find(item => item.name === 'entry_type')
        return record ? record.values : false
      }
    },
    sectionTitle:{
      get () {
        return this.$route.name === 'new_item'
        ? 'Add New Library Record'
        : this.content ? this.content.title.rendered : ''
      }
    },
    toPost: {
      get () {
        
        return this.post
      }
    },
    validateForm:{
      get(){
        return true //this.post.to !== '' & this.post.to !== undefined ? true: false 
      }
    }
  },
  methods:{
    $_evaluateField(field) {
      if( field.isFor && Array.isArray(field.isFor)) {
        return field.isFor.includes(this.post.entry_type)
      } else
      return !field.isFor || field.isFor === this.post.entry_type
    },
    $_fetchTs() {
      contentService.getSingleEntry(this.$route.params.id) 
      .then(res => { 
        this.content = res.data
        let booking = res.data.acf.book ?  res.data.acf.book : ''
        let legislation = res.data.acf.legislation ?  res.data.acf.legislation : ''
        let judgment = res.data.acf.Judgments ?  res.data.acf.Judgments : ''
      this.fields =  libraryFields.populate({
        entry_type: res.data.acf.entry_type,
        name:res.data.title.rendered,
        sub_title: res.data.acf.sub_title,
        ...booking,
        ...legislation,
        ...judgment,
      })
      const isforChecker = (x) => {
        return Array.isArray(x.isFor) 
        ? x.isFor.includes(res.data.acf.entry_type)
        : x.isFor === res.data.acf.entry_type || !x.isFor
      }
      setTimeout(() => {
        this.fields.forEach(x => {
          if(isforChecker(x)) {
            this.$_fieldsData({
            name:x.name,
            data:x.values
          })
          }
 
        })
      }, 100);
        setTimeout(() => {
        core.updateFields()
      }, 1000);
      })
    },
    $_vModal(){
      this.modal.instance = core.initModal(this.$refs.modal, this.modal.options)
      setTimeout(() => {
        this.modal.instance.open()
      }, 300);
    },
    $_filesToUpload($event){
     this.uploads.data.length < 0
     ? this.uploads.data = $event.data
     : this.uploads.data = [...this.uploads.data, ...$event.data]
    },
    $_processFiles(){
 
      let promises = this.uploads.data.map(item => contentService.uploadFile(item.data))
      const count =  {
          promises:promises.length,
          sucess:0,
          files:new Array,
      }
      Promise.all(promises)
        .then(res=>{         
         count.sucess = count.sucess + 1
         count.files.push({file:res[count.sucess - 1].data.id})
         this.uploads.added.push({file:res[count.sucess - 1].data.id})
         if(count.promises === count.sucess) {
          
           this.uploads.ready = true
           setTimeout(() => {
             this.$_saveRecord()
           }, 100);
            window.console.log('uploadDone')          
          }        
        })
    },
    $_fieldsData($event){
      const record =  this.fields.find(item => item.name === $event.name)
      if (record) {
        record.type === 'select' && $event.data !== ""
        ?  this.post[record.name] = $event.data && $event.data.prop ? $event.data.prop : $event.data
        :  this.post[record.name] = $event.data
        }
        this.$forceUpdate()
    },
    $_toggleFullScreen(){ 
        this.$refs.modal.classList.toggle('fullScreen')  
        let test = () => {
           return  this.$refs.modal.classList.contains('fullScreen')
        } 
       if(test()) {
          this.fullScreen = true
       }
      if(!test()) {
        this.fullScreen = false        
      }
    },
    $_goBack(){
      this.$router.go(-1)
    },
    $_editValues($event){
      let payload = {
        action:'update_field_values',
        uid:$event.field,
        data:$event.values
      }
      this.$store.commit('ADD_FIELDS_DATA', payload)
    },
    $_sendNotificaiton(data){
      let fromUser = this.users.find(user => user.id === parseInt(data.acf.from))
      let toUser = this.users.find(user => user.id === parseInt(data.acf.to))
      let payload = {
        from:fromUser.acf.first_name +' '+ fromUser.acf.last_name,
        to:toUser.acf.first_name +' '+toUser.acf.last_name,
        record:data.acf.id,
        routeuser:toUser.acf.email,
        message:`New record created by user see below for details`,
        url:`https://docs.eccourts.org/records/record/view/${data.id}`,
      }
      formService.newRecord(payload)
      .then(res =>{ 
        window.console.log(res)
      })
    },
    $_postStructure(){
        const mapValue = (prop) =>{
          const record = this.fields.find(item => item.name === prop )
          return record ? record.values : ''
        }
        return {
          name: mapValue('name'),
          case_number: mapValue('case_number'),
          requesting_party: mapValue('requesting_party'),
          transcriptionist: mapValue('transcriptionist'),
          case_name: mapValue('case_name'),
          practitioners: mapValue('practitioners'),
          heard:mapValue('heard'),
          judges: mapValue('judges') ? mapValue('judges').map(e => {return {judge: e.notes}}) : '',
          appearances: mapValue('appearances'),
          logs: mapValue('logs'),
          status: mapValue('status').prop,
          request_form: mapValue('request_form'),
          file_links: mapValue('file_links') && mapValue('file_links').length ? mapValue('file_links').map(e => {return {url: e.notes}}) : '',
         // other_attachments:''
        }
    },
    $_saveCheck(){
      if ( this.uploads.data.length > 0){
        this.$_processFiles()
      } else {
        setTimeout(() => {
          this.$_saveRecord()
        }, 500);
      }
    },
    $_saveRecord (){
      let judgments = {
        Judgments:{
          ...this.toPost,
          file_upload:this.uploads.ready ? this.uploads.added[0].file : ''
        }
      }
      let legislation = {
          legislation: {
          ...this.toPost,
          file_upload:this.uploads.ready ? this.uploads.added[0].file : ''
        }
      }
      let book = {
        book:{
          ...this.toPost,
          file_upload:this.uploads.ready ? this.uploads.added[0].file : ''
        }
      }
      let toPostType = this.post.entry_type === 'Judgments'
      ? judgments 
      : this.post.entry_type === 'Legislation'
        ? legislation
        : book
      const structure = {
        title: this.post.name,
        status:'publish',
        categories:[44],
        fields:{          
          sub_title: this.post.sub_title,
          entry_type: this.post.entry_type,
          ...toPostType
        //  other_attachments: this.uploads.added.map(item=> item.file)
        }
      }
      
      contentService.saveLibraryEntries(structure)
      .then(res=>{
        core.toastMessage('Item Added Successfully')
      window.console.log(res)

        this.fields.forEach(option => option.type !== 'date' ? option.values = "" : false)
        this.post = new Object
      
        setTimeout(() => {
          this.ready = true
          this.sending = false
           this.$forceUpdate()
        }, 600); 
      })
    },
  }
}
</script>
<style lang="scss" scoped>
#form{
  &.modal {
     min-height: 85% !important;
    &.fullScreen {
      top: 0 !important;
      width: 100% !important;
      min-height: 100% !important;
    }
  }
  @media screen and (max-width: 680px){
    width:100%;
    top:0% !important;
    height: 100%;
    min-height: 100%;
  }
  &.modal.with-header {
    padding: 0;
    border-radius:6px;
    height: 70%;
  .header-wrapper {
    height:56px;
    position: relative;
    .modal-header {
      position: absolute;
      width:100%;
      padding:20px;
      top: 0;
      line-height:56px;
      height:100%;
      padding:0px 20px;
      border-bottom: .4px solid rgba(0,0,0,0.4);
      .title {
        font-size: 22px;
        display: inline;
      }
      ul {
        display: inline-flex;
        margin:0px;
         li {

           a {
             cursor: pointer;
             margin:0 8px;
              i {
                line-height: 56px;
              }
           }
         }
      }
    }
  }
  .modal-content {
    position: absolute;
    height: calc(100% - 122px);
    max-height: 100%;
    width: 100%;
    top:56px;
    padding:20px;
    overflow-y: auto;
  }
 }
  .custom-footer {
    position: fixed;
    bottom: 0;
    left:0;
    padding: 15px;
    width: 100%;
    background: white;
  }

.loader-container {
  top:50%;
  left:50%;
  width:64px;
  height: 64px;
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: 9;
}

}
</style>
<style lang="scss">

#form {
    .input-field>label {
    //  top: 0;
      left: 10px;
      width: auto;
      
      color:black;
      &.active {
        
        margin-top: 5px;
        width: auto;
        }
      }
    input[type=text]:not(.dropdown-trigger), 
    input[type=text]:not(.browser-default), 
    input[type=number]:not(.browser-default),
    input[type=email]:not(.browser-default),
    input[type=select]:not(.browser-default){
      border: 1px solid rgba(158, 158, 158, 0.35);
      width: calc(100% - 16px);
      margin: 0 0 8px 0;
      padding: 0 8px;
      border-radius:4px;
      background:white;
    }
    textarea.materialize-textarea{
      box-shadow:none !important;
      border-radius:4px;
      border: 1px solid rgba(158, 158, 158, 0.35);
      margin: 0 0 8px 0;
      padding: 16px;
      min-height: 80px;
      background:white;
    }
}
</style>